<div>
    <div class="modal-header">
        <h6 style="font-weight: 600;">Edit Supplier IFA</h6>
    </div>
    <div class="modal-body">
        <form [formGroup]="editSupplierForm">
            <div class="row">
                <div class="form-group col-3">
                    <label for="purchase_organization">Purchasing organization <span style="color:red">*</span></label>
                    <input class="form-control form-control-sm" type="text" id="purchase_organization" 
                        formControlName="purchase_organization">
                </div>
                <div class="form-group col-3">
                    <label for="plant_code">Plant<span style="color:red">*</span></label>
                    <input class="form-control form-control-sm" type="text" id="plant_code" 
                        formControlName="plant_code">
                </div>
                <div class="form-group col-3">
                    <label for="purchase_group">Purchasing group</label>
                    <input class="form-control form-control-sm" type="text" id="purchase_group"
                        formControlName="purchase_group">
                </div>
            </div>
            <fieldset>
                <legend>Alerts</legend>

                <div class="alert-section">
                    <div>
                        <input type="checkbox" id="isEnableDelivery" formControlName="isEnableDelivery" (change)="ensureChecked($event)">
                        <label for="isEnableDelivery">Delivery Overdue</label>
                        <div class="row">
                            <div class="col-6">

                            </div>
                            <div class="col-4">
                                <div class="frequency-options">
                                    <label>Frequency:</label>
                                    <input type="radio" id="sendDeliveryFrequency"
                                        formControlName="sendDeliveryFrequency" value="daily">
                                    <label for="sendDeliveryFrequency">Daily</label>
                                    <input type="radio" id="sendDeliveryFrequency" 
                                        formControlName="sendDeliveryFrequency" value="weekly">
                                    <label for="sendDeliveryFrequency">Weekly</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>
                        <input type="checkbox" id="isEnableConfirmation" formControlName="isEnableConfirmation" (change)="ensureChecked($event)">
                        <label for="isEnableConfirmation">Missing Order Confirmation</label>
                        <div class="row">
                            <div class="col-6">
                                <div class="form-group">
                                    <label for="confirmaReminder">Days after release</label>
                                    <input class="form-control form-control-sm" type="number" id="confirmaReminder"
                                        formControlName="confirmaReminder">
                                </div>
                            </div>
                            <div class="col-4">
                            </div>
                        </div>
                    </div>

                    <div>
                        <input type="checkbox" id="isEnableConfirmOverDue" formControlName="isEnableConfirmOverDue" (change)="ensureChecked($event)">
                        <label for="isEnableConfirmOverDue">Missing Order Confirmation Overdue</label>
                            <div  class="row">
                                <div class="col-6">
                                    <div class="form-group">
                                        <label for="confirmOverDueReminder">Days after release</label>
                                        <input class="form-control form-control-sm" type="number" id="confirmOverDueReminder"
                                            formControlName="confirmOverDueReminder">
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="frequency-options">
                                        <label>Frequency:</label>
                                        <input type="radio" id="sendConfirmationFrequency" 
                                            formControlName="sendConfirmationFrequency" value="daily">
                                        <label for="sendConfirmationFrequency">Daily</label>
                                        <input type="radio" id="sendConfirmationFrequency" 
                                            formControlName="sendConfirmationFrequency" value="weekly">
                                        <label for="sendConfirmationFrequency">Weekly</label>
                                    </div>
                                </div>
                            </div>
                    </div>

                    <div>
                        <input type="checkbox" id="isEnableDeliverOverDue" formControlName="isEnableDeliverOverDue" (change)="ensureChecked($event)">
                        <label for="isEnableDeliverOverDue">Delivery Reminder</label>
                        <div class="row">
                            <div class="col-6">
                                <div class="reminder-section">
                                    <div class="form-group">
                                        <label for="deliveryReminderFirst">First reminder</label>
                                        <input class="form-control form-control-sm" type="number" id="deliveryReminderFirst"
                                           formControlName="deliveryReminderFirst">
                                    </div>
                                    <div class="form-group">
                                        <label for="deliveryReminderSecond">Second reminder</label>
                                        <input class="form-control form-control-sm" type="number" id="deliveryReminderSecond"
                                            formControlName="deliveryReminderSecond">
                                    </div>
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="transport-options">
                                    <label>Include transportation time:</label>
                                    <input type="radio" id="includeTransportationTime" 
                                        formControlName="includeTransportationTime" [value]="true">
                                    <label for="yes">Yes</label>
                                    <input type="radio" id="includeTransportationTime" 
                                        formControlName="includeTransportationTime" [value]="false">
                                    <label for="no">No</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </fieldset>
        </form>
    </div>

    <div class="modal-footer">
        <button class="btn btn-outline-primary mx-2" (click)="onModalClose()">Cancel</button>
        <button class="btn btn-primary text-white mx-2" (click)="SaveDetails()"
            [disabled]="!editSupplierForm.valid">Save</button>
    </div>
</div>